import React from 'react'
import { Advisor, AdvisorData, RoboAdvisorData } from '../../../utils/types'
import { isAdvisorData, isFirmAdvisorData, isHumanAdvisorData, isNetworkAdvisorData, isRoboAdvisorData } from './advisorTypeGuards'
import { getFeeStructureMapping, getTypeLabel, parseMiles } from './advisorUtils'
import { AdvisorStat } from './AdvisorStat'
import { AdvisorLocation } from './AdvisorLocation'
import { useAdvisorCard } from './AdvisorCardContext'
import '../../styles/AdvisorCardsModule/AdvisorStats.scss'

const getFoundedIn = (advisorData: AdvisorData | RoboAdvisorData): string | null => {
  const raw = isRoboAdvisorData(advisorData)
    ? advisorData.advisor.network?.founded_in
    : (isFirmAdvisorData(advisorData) || isNetworkAdvisorData(advisorData))
        ? (advisorData.advisor as Advisor).founded_in
        : null
  return raw && raw !== 'null' ? raw : null
}

export const AdvisorStats = () => {
  const { advisorData, typeLabels, feeStructureTooltips } = useAdvisorCard()
  return (
    <div className='advisor-stats'>
      <div className='advisor-stats__top'>
        {isHumanAdvisorData(advisorData) && advisorData.advisor.experience && (
          <AdvisorStat
            label={getTypeLabel('experience', typeLabels)}
            value={advisorData.advisor.experience}
          />
        )}
        {getFoundedIn(advisorData) && (
          <AdvisorStat
            label={getTypeLabel('founded_in', typeLabels)}
            value={getFoundedIn(advisorData)!}
          />
        )}
        {!isRoboAdvisorData(advisorData) && advisorData.advisor.fee_structure && (
          <AdvisorStat
            label={getTypeLabel('fee_structure', typeLabels)}
            value={advisorData.advisor.fee_structure}
            tooltip={getFeeStructureMapping(advisorData.advisor.fee_structure, feeStructureTooltips)}
          />
        )}
      </div>
      {isAdvisorData(advisorData) && !isRoboAdvisorData(advisorData) && advisorData.advisor.location && parseMiles(advisorData.distance) <= 25 && (
        <AdvisorLocation location={advisorData.advisor.location} distance={advisorData.distance}/>
      )}
    </div>
  )
}
